import toast from "react-hot-toast";
import i18next from "i18next";
import {BaseClient} from "../../Api/HttpClient";

export const createInvoiceSlice = (set, get) => ({
    invoices: [],
    invoiceDetail: {},
    invoicesMetaData: {},

    getMyInvoices: async (status = [], searchFilter = '', page = 1) => {
        try {
            const params = new URLSearchParams();
            if (searchFilter) {
                params.append('search', searchFilter);
            }
            if (status.length > 0) {
                params.append('status', status.join(','));
            }
            params.append('page', page);

            const response = await BaseClient().get('/invoices?' + params.toString());
            if (response.status === 200) {
                set({
                    invoices: response.data?.data || [],
                    invoicesMetaData: response.data?.meta || {}
                });
                return {
                    data: response.data?.data || [],
                    meta: response.data?.meta || {}
                };
            } else {
                toast.error(response.data);
                return { data: [], meta: {} };
            }
        } catch (error) {
            console.error('Error fetching invoices:', error);
            toast.error(i18next.t('invoices.toast_fetch_error'));
            return { data: [], meta: {} };
        }
    },

    getInvoice: async (invoiceId) => {
        await BaseClient().get(`/invoices/${invoiceId}`)
            .then(response => {
                if (response.status === 200) {
                    set({invoiceDetail: response.data})
                } else {
                    toast.error(response.data);
                }
            })
    },

    regenerateInvoice: async (invoiceId) => {
        await BaseClient().post(`/invoices/${invoiceId}/regenerate`)
            .then(response => {
                if (response.status === 200) {
                    toast.success(i18next.t('invoices.toast_regenerate_success'));
                } else {
                    toast.error(response.data);
                }
            })
    },

    markInvoiceAsPaid: async (invoiceId) => {
        try {
            const response = await BaseClient().post(`/invoices/${invoiceId}/mark-as-paid`);
            if (response.status === 200) {
                toast.success(i18next.t('invoices.toast_mark_paid_success'));
                return true;
            } else {
                toast.error(response.data);
                return false;
            }
        } catch (error) {
            toast.error(i18next.t('invoices.toast_mark_error'));
            console.error(error);
            return false;
        }
    },

    getInvoicesForUser: async (userId, page = 1, branchId = null) => {
        try {
            const params = new URLSearchParams();
            params.append('page', page);

            if (branchId) {
                params.append('branch_id', branchId);
            }

            const response = await BaseClient().get(`/users/${userId}/invoices?${params.toString()}`);
            if (response.status === 200) {
                return {
                    data: response.data?.data || [],
                    meta: response.data?.meta || {}
                };
            } else {
                toast.error(response.data);
                return { data: [], meta: {} };
            }
        } catch (error) {
            console.error('Error fetching invoices for user:', error);
            toast.error(i18next.t('invoices.toast_fetch_error'));
            return { data: [], meta: {} };
        }
    },

    getAllInvoices: async (filters = {}) => {
        try {
            const params = new URLSearchParams();

            if (filters.customer_id) {
                params.append('customer_id', filters.customer_id);
            }

            if (filters.branch_id) {
                params.append('branch_id', filters.branch_id);
            }

            if (filters.from) {
                params.append('from', filters.from);
            }

            if (filters.to) {
                params.append('to', filters.to);
            }

            if (filters.status) {
                params.append('status', filters.status);
            }

            if (filters.page) {
                params.append('page', filters.page);
            }

            const response = await BaseClient().get(`/invoices/all?${params.toString()}`);
            if (response.status === 200) {
                return {
                    data: response.data?.data || [],
                    meta: response.data?.meta || {}
                };
            } else {
                toast.error(response.data?.message || i18next.t('invoices.toast_fetch_error'));
                return { data: [], meta: {} };
            }
        } catch (error) {
            console.error('Error fetching all invoices:', error);
            toast.error(i18next.t('invoices.toast_fetch_error'));
            return { data: [], meta: {} };
        }
    },

    markInvoiceAsReadyForExact: async (invoiceId) => {
        try {
            const response = await BaseClient().post(`/invoices/${invoiceId}/mark-as-ready-for-exact`);
            if (response.status === 200) {
                toast.success(i18next.t('invoices.toast_mark_ready_exact_success'));
                return true;
            } else {
                toast.error(response.data?.message || i18next.t('general.errors.generic'));
                return false;
            }
        } catch (error) {
            toast.error(i18next.t('invoices.toast_mark_error'));
            console.error(error);
            return false;
        }
    }
})